import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import styles from "./index.module.scss";

type IProps = Immutable<{
    className?: string;
}>;

export const LoadingSpinner = (props: IProps): React.JSX.Element => {
    return (
        <div
            className={classNames(
                "loading-spinner",
                "l-capped-width",
                props.className,
            )}
            aria-label={t`Loading`}
        >
            <div className="loading-spinner__inner">
                <span className={styles.bounce} />
                <span className={styles.bounce} />
                <span className={styles.bounce} />
            </div>
        </div>
    );
};
